import React from 'react';
import { Truck } from 'lucide-react';
import LegalPageLayout, { LegalSection } from './LegalPageLayout';

const ShippingPage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  return (
    <LegalPageLayout
      title="الشحن والتوصيل"
      icon={<Truck className="h-8 w-8" />}
      lastUpdated="17 يوليو 2026"
      totalItems={totalItems}
      totalFavorites={totalFavorites}
      setCurrentPage={setCurrentPage}
    >
      <LegalSection title="مناطق التوصيل">
        <p>
          نوفر خدمة التوصيل حاليًا لمعظم المناطق داخل نطاق تغطيتنا، ويمكنك التأكد من إمكانية
          التوصيل لمنطقتك عند إدخال عنوانك أثناء إتمام الطلب.
        </p>
      </LegalSection>

      <LegalSection title="مدة التوصيل">
        <ul className="list-inside list-disc space-y-2">
          <li>الطلبات داخل المدينة: خلال 1 إلى 3 ساعات من تأكيد الطلب.</li>
          <li>الطلبات خارج نطاق التوصيل السريع: خلال 24 إلى 48 ساعة.</li>
          <li>قد تختلف المدة في أوقات الذروة أو الظروف الجوية الاستثنائية.</li>
        </ul>
      </LegalSection>

      <LegalSection title="رسوم التوصيل">
        <p>
          تُحتسب رسوم التوصيل حسب المسافة والمنطقة، ويظهر السعر النهائي بوضوح قبل تأكيد الطلب.
          كما نوفر توصيلًا مجانيًا عند تجاوز الطلب حدًا معينًا من قيمة المشتريات.
        </p>
      </LegalSection>

      <LegalSection title="تتبع الطلب">
        <p>
          بمجرد تأكيد طلبك، يمكنك متابعة حالته لحظة بلحظة من خلال صفحة "طلباتي" في حسابك،
          بدءًا من التجهيز وحتى وصوله إليك.
        </p>
      </LegalSection>

      <LegalSection title="ملاحظات هامة">
        <p>
          يُرجى التأكد من صحة العنوان ورقم الهاتف عند إتمام الطلب لتفادي أي تأخير، وفي حال تعذر
          الوصول إليك سيقوم مندوب التوصيل بالتواصل معك مباشرة لتنسيق موعد بديل.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default ShippingPage;
